import React, {useState, useEffect} from 'react';
import Notify from '../Notify';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'
import { getDefaultNormalizer } from '@testing-library/react';

class FinishShift extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        originalStartTime:"",
        originalFinishTime:Time.getComputerTimeDate(),
        startDateTime:"",
        finishDateTime:"",
        workingTimeResult:"",
        breakTime:0,
    };
    this.handleFormTimeChange = this.handleFormTimeChange.bind(this);
    this.registerEndShift = this.registerEndShift.bind(this);
  }

  handleFormTimeChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  registerEndShift = async() =>{
        if(this.state.workingTime < 0){
            return;
        }
        //Prepare the data to finish the shift
        let shiftId = localStorage.getItem("shiftId");
        let startTime = this.state.startDateTime;
        let finishTime = Time.getComputerTimeDate();
        let breakTime = localStorage.getItem("timeResting");
        let endTimeDate = this.state.finishDateTime;

        var formdata = new FormData();
        formdata.append("shiftid", shiftId);
        formdata.append("startTimeDate", startTime);
        formdata.append("endTimeDate", endTimeDate);
        formdata.append("originalEndTimeDate", finishTime);
        formdata.append("breakMinutes", breakTime);


        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        await fetch("https://dashboard.realsexdoll.info/php/timesheet/endshift.php", requestOptions)
        .then(response => response.text())
        .then(result => this.props.close())
        .catch(error => console.log('error', error));

        //Cleans Local Storage
        localStorage.clear();
        this.props.end();
        this.props.close();
  }

  componentDidMount= async() =>{
    //Getting data from local storage and inserting into the state of this component
    let currentTime = Time.getComputerTimeDate();
    let localStoragebreakTime = localStorage.getItem("timeResting");
    
    let lastShift;
    var formdata = new FormData();
    formdata.append("user", this.props.user);
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
    await fetch("https://dashboard.realsexdoll.info/php/timesheet/getlastshift.php", requestOptions)
      .then(response => response.json())
      .then(result => lastShift = result)
      .catch(error => console.log('error', error));

    let localStorageStartDateTime = lastShift.StartTime;
    //let localStorageStartDateTime = localStorage.getItem("startingTime");

    let finalTime = new Date();
    let inicialTime = new Date(localStorageStartDateTime)

    let localStorageWorkingTime = (finalTime - inicialTime)/1000;

    this.setState({startDateTime:localStorageStartDateTime});
    this.setState({breakTime:localStoragebreakTime});
    this.setState({finishDateTime:currentTime});
    
    console.log(localStorageWorkingTime);
    if(localStorageWorkingTime > 0){
        this.setState({workingTimeResult:Time.convertSecondsToString(localStorageWorkingTime)})
    }else{
        this.setState({workingTimeResult:""})
    }

  }

  render() {

    let totalHours;
    let startingDate = new Date(this.state.startDateTime);
    let finishDate = new Date(this.state.finishDateTime);
    totalHours = (finishDate-startingDate)/1000
    let result;
    if(totalHours <= 0){
        result = "Invalid hours try again"
    }else{
        result = Time.convertSecondsToString(totalHours);
    }    
    
    return(
        <div>
            <div className='pop-up'></div>
            <div className="container pop-up-window">
                <div className="row">
                    <div className="col-12 container p-4">
                        <h3>{this.props.user}, let's just confirm your shift today</h3>
                        <p>Break time: {Time.convertSecondsToString(this.state.breakTime * 60)}</p>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <label className="form-label">Start Date and Time</label>
                            <input onChange={this.handleFormTimeChange} defaultValue={this.state.startDateTime} type="datetime-local" className="form-control" id="startDateTime" required></input>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <label className="form-label">Finish Date and Time</label>
                            <input onChange={this.handleFormTimeChange} defaultValue={this.state.finishDateTime} type="datetime-local" className="form-control" id="finishDateTime" required></input>
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <p>Total: {result}</p>
                        </div>
                    </div>
                    <div className="col-12 container p-4">
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button onClick={this.registerEndShift}>Finish shift</button>
                            <button onClick={this.props.close}>Resume shift</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default FinishShift;